export enum ItemType {
  Item = 'item',
  ItemScheduled = 'item-scheduled',
  ItemLive = 'item-live',
  ItemLiveFinalize = 'item-live-finalize',
}
